
export const strToBool = (str: string | undefined): boolean => {
    return  str?.toLocaleLowerCase().trim() === "true"; 
}; 